// Từ điển dùng chung (shell + @hana/ui). Khoá dạng `nhóm.tên`. Vùng thêm khoá của mình qua `addMessages`.
// Mã nghiệp vụ (BL, ETD, VGM, HS, mã phí), tên riêng và dữ liệu KHÔNG đưa vào từ điển.
export type Locale = 'vi' | 'en';
export type Messages = Record<string, string>;

export const vi: Messages = {
  'common.search': 'Tìm nhanh',
  'common.save': 'Lưu',
  'common.cancel': 'Huỷ',
  'common.close': 'Đóng',
  'common.undo': 'Hoàn tác',
  'common.retry': 'Thử lại',
  'common.loading': 'Đang tải…',
  'state.empty': 'Chưa có dữ liệu',
  'state.error': 'Không tải được dữ liệu',
  'state.noperm': 'Bạn chưa có quyền xem mục này',
  'theme.toDark': 'Chuyển giao diện tối',
  'theme.toLight': 'Chuyển giao diện sáng',
  'settings.language': 'Ngôn ngữ',
  'count.items': '{n} mục',
  'shell.userMenu': 'Menu người dùng',
  'shell.feedback': 'Góp ý',
  'shell.dock': 'Bảng bên phải',
  'shell.dockClose': 'Đóng bảng',
  'shell.dockCloseRight': 'Đóng cột phải',
  'shell.signOut': 'Đăng xuất',
  'shell.nav': 'Điều hướng',
  'shell.navMain': 'Điều hướng chính',
  'shell.moreTab': 'Thêm',
  'shell.zones': 'Chuyển vùng',
  'shell.collapse': 'Thu gọn menu',
  'shell.expand': 'Mở rộng menu',
  'shell.closeMenu': 'Đóng menu',
  'shell.openMenu': 'Mở menu',
  'shell.zone': 'Vùng',
  'shell.me': 'Tôi',
  'shell.light': 'Sáng',
  'shell.dark': 'Tối',
  'shell.findK': 'Tìm nhanh (Ctrl K)',
  'shell.findKt': 'Tìm nhanh · Ctrl K',
  'shell.findScreen': 'Tìm màn',
  'shell.findScreenPh': 'Tìm màn trong vùng…',
  'shell.results': 'Kết quả',
  'shell.findZone': 'Tìm vùng',
  'shell.allZones': 'Tất cả vùng',
  'shell.findZonePh': 'Tìm vùng · ví dụ mail, lương, chat',
  'shell.askFull': 'Mở Ask HANA toàn trang',
  'shell.openFull': 'Mở toàn trang',
  'shell.askClose': 'Đóng Ask HANA',
  'shell.askFabLabel': 'Hỏi Ask HANA',
  'shell.askFab': 'Ask HANA · bấm để mở lệnh nhanh · kéo để di chuyển (hoặc phím mũi tên, Shift để đi xa) · Ctrl+Alt+D',
  'shell.context': 'Ngữ cảnh',
  'shell.askSoon': 'Ask HANA sắp có',
  'shell.askSoonDesc': 'Hỏi về màn đang mở, tìm job, tóm tắt việc. Đang dựng.',
  'shell.askInput': 'Hỏi Ask HANA',
  'shell.askPh': 'Hỏi về màn đang mở…',
  'shell.askSend': 'Gửi câu hỏi',
  'shell.askOff': 'Ask HANA chưa bật',
  'shell.askNote': 'Không tự thực thi · thao tác ghi cần duyệt',
  'shell.analytics': 'Phân tích',
  'shell.tasks': 'Việc',
  'shell.mailList': 'Thư cạnh danh sách',
  'shell.noti': 'Thông báo',
  'shell.more': 'Thao tác khác',
  'shell.crumb': 'Vị trí',
  'shell.fbSend': 'Gửi góp ý',
  'shell.fbKind': 'Loại góp ý',
  'shell.fbDesc': 'Mô tả',
  'shell.fbCtx': 'Ngữ cảnh tự ghi',
  'shell.screen': 'Màn',
  'shell.display': 'Màn hình',
  'shell.fbDone': 'Đã ghi góp ý · kênh gửi Admin IT đang dựng',
  'shell.fbBug': 'Lỗi',
  'shell.fbIdea': 'Đề xuất',
  'shell.fbPh': 'Bấm gì, thấy gì, mong gì…',
  'shell.noZone': 'Không có vùng khớp “{q}”',
  'shell.current': ' · đang mở',
  'shell.noScreen': 'Không có màn khớp “{q}”',
  'ui.selectAll': 'Chọn tất cả',
  'ui.select': 'Chọn {k}',
  'ui.bulk': 'Thao tác hàng loạt',
  'ui.selected': 'Đã chọn {n} {noun}',
  'ui.clearSel': 'Bỏ chọn',
  'ui.remove': 'Bỏ {label}',
  'ui.closeToast': 'Đóng thông báo',
  'state.nopermTitle': 'Không có quyền xem',
  'state.emptyTitle': 'Chưa có dữ liệu',
  'notes.title': 'Ghi chú',
  'notes.count': '{n} nội bộ',
  'notes.stopCount': '{n} tại điểm',
  'notes.add': 'Viết ghi chú',
  'notes.toggle': 'Mở hoặc gập Ghi chú',
  'notes.pin': 'Ghim ghi chú: {text}',
  'notes.unpin': 'Bỏ ghim ghi chú: {text}',
  'notes.empty': 'Chưa có ghi chú nội bộ.',
};

export const en: Messages = {
  'common.search': 'Quick find',
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.undo': 'Undo',
  'common.retry': 'Retry',
  'common.loading': 'Loading…',
  'state.empty': 'No data yet',
  'state.error': 'Could not load data',
  'state.noperm': 'You do not have access to this',
  'theme.toDark': 'Switch to dark theme',
  'theme.toLight': 'Switch to light theme',
  'settings.language': 'Language',
  'count.items': '{n} items',
  'shell.userMenu': 'User menu',
  'shell.feedback': 'Feedback',
  'shell.dock': 'Side panel',
  'shell.dockClose': 'Close panel',
  'shell.dockCloseRight': 'Close right panel',
  'shell.signOut': 'Sign out',
  'shell.nav': 'Navigation',
  'shell.navMain': 'Main navigation',
  'shell.moreTab': 'More',
  'shell.zones': 'Switch area',
  'shell.collapse': 'Collapse menu',
  'shell.expand': 'Expand menu',
  'shell.closeMenu': 'Close menu',
  'shell.openMenu': 'Open menu',
  'shell.zone': 'Area',
  'shell.me': 'Me',
  'shell.light': 'Light',
  'shell.dark': 'Dark',
  'shell.findK': 'Quick find (Ctrl K)',
  'shell.findKt': 'Quick find · Ctrl K',
  'shell.findScreen': 'Find screen',
  'shell.findScreenPh': 'Find a screen in this area…',
  'shell.results': 'Results',
  'shell.findZone': 'Find area',
  'shell.allZones': 'All areas',
  'shell.findZonePh': 'Find area · e.g. mail, payroll, chat',
  'shell.askFull': 'Open Ask HANA full page',
  'shell.openFull': 'Open full page',
  'shell.askClose': 'Close Ask HANA',
  'shell.askFabLabel': 'Ask HANA',
  'shell.askFab': 'Ask HANA · click for quick commands · drag to move (or arrow keys, Shift for bigger steps) · Ctrl+Alt+D',
  'shell.context': 'Context',
  'shell.askSoon': 'Ask HANA coming soon',
  'shell.askSoonDesc': 'Ask about the open screen, find jobs, summarise work. In progress.',
  'shell.askInput': 'Ask HANA',
  'shell.askPh': 'Ask about the open screen…',
  'shell.askSend': 'Send question',
  'shell.askOff': 'Ask HANA is not enabled yet',
  'shell.askNote': 'Never runs on its own · write actions need approval',
  'shell.analytics': 'Analytics',
  'shell.tasks': 'Tasks',
  'shell.mailList': 'Mail beside list',
  'shell.noti': 'Notifications',
  'shell.more': 'More actions',
  'shell.crumb': 'Location',
  'shell.fbSend': 'Send feedback',
  'shell.fbKind': 'Feedback type',
  'shell.fbDesc': 'Description',
  'shell.fbCtx': 'Auto-captured context',
  'shell.screen': 'Screen',
  'shell.display': 'Display',
  'shell.fbDone': 'Feedback noted · the Admin IT channel is being built',
  'shell.fbBug': 'Bug',
  'shell.fbIdea': 'Idea',
  'shell.fbPh': 'What you clicked, what you saw, what you expected…',
  'shell.noZone': 'No area matches “{q}”',
  'shell.current': ' · current',
  'shell.noScreen': 'No screen matches “{q}”',
  'ui.selectAll': 'Select all',
  'ui.select': 'Select {k}',
  'ui.bulk': 'Bulk actions',
  'ui.selected': '{n} {noun} selected',
  'ui.clearSel': 'Clear selection',
  'ui.remove': 'Remove {label}',
  'ui.closeToast': 'Dismiss notification',
  'state.nopermTitle': 'No access',
  'state.emptyTitle': 'No data yet',
  'notes.title': 'Notes',
  'notes.count': '{n} internal',
  'notes.stopCount': '{n} at stops',
  'notes.add': 'Write a note',
  'notes.toggle': 'Expand or collapse Notes',
  'notes.pin': 'Pin note: {text}',
  'notes.unpin': 'Unpin note: {text}',
  'notes.empty': 'No internal notes yet.',
};
